import React from 'react';
import ReactMarkdown from 'react-markdown';

import CopyToClipboard from '@/app-components/resouces//CopyToClipboard';
import { BgDpcCodeType } from '@/data/dtos/Resouces/BgDentalProcedureCodes/BgDpcCodeType';
import { Link } from '@/i18n/routing';


interface ResourceMarkdownProps {
	children?: string | null | undefined,
	pClassName?:string | undefined, 
	pToSpan?: boolean, 
	codes?: BgDpcCodeType[]|null
}

function renderCodeComponent(codeItem: BgDpcCodeType) {
    return (
      <span key={codeItem.code} className="d-inline-flex align-items-center">
        <Link
			href={codeItem.siteLink}
			className="btn border btn-sm btn-light font-monospace p-1 m-1"
			data-bs-toggle="tooltip"
			data-placement="top"
			data-bs-title={codeItem.name}
			title={codeItem.name}
			>
          {codeItem.code}
        </Link>

        <CopyToClipboard textToCopy={codeItem.code}>
          <a
            className="btn btn-sm btn-light me-2 p-1 m-0"
            data-bs-toggle="tooltip"
            data-placement="top"
            data-bs-title="Copy code"
          >
            <i className="bi bi-copy" title="Copy code"></i>
          </a>
        </CopyToClipboard>
      </span>
    );
}

function processChildrenWithCodes(children: React.ReactNode, codes: BgDpcCodeType[] | null) {
    return React.Children.map(children, (child) => {
        if (typeof child === "string" && codes) {
            const parts = child.split(/(\[\d{5}-\d{2}\])/g); // Match [codes]
            return parts.map((part, index) => {
                const matchedCode = codes.find((code) => `[${code.code}]` === part);
                if (matchedCode) {
                    return renderCodeComponent(matchedCode);
                }
                return <React.Fragment key={index}>{part}</React.Fragment>;
            });
        }
        return child;
    });
}

export default function ResourceMarkdown({ children, pClassName = "mb-2", pToSpan = false, codes = null}: ResourceMarkdownProps) {
	if (! children) {
		return;
	}

	const customComponents = {
		p: ({ node, children, ...props }: any) => {
			const processedChildren = processChildrenWithCodes(children, codes);
			return pToSpan ? (
				<span className={pClassName} {...props}>
					{processedChildren}
				</span>
			) : (
				<p className={pClassName} {...props}>
					{processedChildren}
				</p>
			);
		},
		li: ({ node, children, ...props }: any) => {
			const processedChildren = processChildrenWithCodes(children, codes);
			return (
				<li {...props}>
					{processedChildren}
				</li>
			);
		},
		a: ({ node, ...props }: any) => (
			<a className="heading-color text-decoration-underline" {...props} />
		),
	};
	
	return <ReactMarkdown
				components={customComponents}
				>
				{children}
			</ReactMarkdown>;
}
